export default __webpack_public_path__ + "static/media/BRN.e6615f75.png";